import { AbsoluteCenter, Box, Flex, Grid, Image, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { NavLink, useLocation, useSearchParams } from 'react-router-dom';

import { COMMON_WEB_PATH } from '../../../../constant';
import { useTranslation } from 'react-i18next';

const hotType = [
  // {
  //   type: 'EXCU',
  //   label: '獨家',
  //   hash: 'exclusiveBrandGames'
  // },
  {
    type: 'HOT',
    label: '熱門',
    hash: 'Popular'
  },
  {
    type: 'NEW',
    label: '最新',
    hash: 'New'
  }
];

const HotTypeMenu = () => {
  const { t } = useTranslation();

  const location = useLocation();

  const [searchParams] = useSearchParams();

  const searchParamsType = searchParams.get('type') || 'Popular';

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      el?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.hash]);

  return (
    <Grid
      templateColumns={'repeat(2, 1fr)'}
      w="100%"
      h="60px"
      position="relative"
    >
      {hotType.map((item) => {
        return (
          <Flex
            as={NavLink}
            to={{
              search: `?type=${item.hash}`
            }}
            align={'center'}
            gap="5px"
            justifyContent={'center'}
            position="relative"
            bgImage={`url('${COMMON_WEB_PATH}/blue-layout/hotType/hotType_background${searchParamsType === item.hash ? '_active' : ''}.png')`}
            bgSize="100% 115%"
            bgRepeat="no-repeat"
            bgPos={'center 9%'}
            px="40px"
          >
            <AbsoluteCenter left="17px">
              <Image
                w="2.5em"
                src={`${COMMON_WEB_PATH}/blue-layout/hotType/${item.type}_icon.png`}
              />
            </AbsoluteCenter>

            <Box>
              <Text
                fontWeight={'400'}
                fontSize="1.4em"
                textShadow={'0 0 1.5px white'}
              >
                {t(`common.${item.label}`)}
              </Text>
            </Box>
          </Flex>
        );
      })}
    </Grid>
  );
};

export default HotTypeMenu;
